export default "__VITE_ASSET__Br6Vl5mU__"